import { observer } from 'mobx-react'
import HomePagePc from './components/HomePagePc/HomePagePc'
import useIsMobile from '@/helpers/commonHooks/useIsMobile'
import usePageBounceTracking from '@/helpers/commonHooks/usePageBounceTracking'
import HomePageMobile from './components/HomePageMobile/HomePageMobile'
import { useEffect } from 'react'
import { TRACKING_TYPES } from '@/services/trackingConst'
import { trackingService } from '@/services/trackingService'


function HomePage() {
  const isMobile = useIsMobile()

  usePageBounceTracking({
    type: TRACKING_TYPES.HOME_PAGE_BOUNCE,
  })

  useEffect(() => {
    trackingService.trackHomePageView()
  }, [])

  return isMobile ? <HomePageMobile /> : <HomePagePc />
}

export default observer(HomePage)
